import * as React from 'react';

const TrashChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="trash-chunky_svg__eds-icon--trash-chunky_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="trash-chunky_svg__eds-icon--trash-chunky_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 19h10V8H7v11z"
        />
        <path
            id="trash-chunky_svg__eds-icon--trash-chunky_top"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 5h-3l-1-1h-4L9 5H6v2h12z"
        />
    </svg>
);

TrashChunkySvg.displayName = 'TrashChunkySvg';
export default TrashChunkySvg;
